<template>
    <div>
        <ProductManufacturingOrigin
            :title="productName"
            :product="product"
            @updated="emitValidity"
        />
        <ProductManufacturingOrigin
            v-if="product.id !== component.id"
            v-for="component in components"
            :title="component.title"
            :parent-title="component.parentTitle"
            :product="component"
            @updated="emitValidity"
        />
    </div>
</template>

<script>
import ProductManufacturingOrigin
    from "@/views/request/received/flow/components/vertiacal-steps/ProductManufacturingOrigin";

export default {
    components: {ProductManufacturingOrigin},
    props: {
        product: {
            type: Object,
            required: true,
        },
        components: {
            type: Array,
            required: true
        }
    },
    methods: {
        emitValidity() {
            let valid = true;

            if (!this.product.countryOfOrigin || !this.product.countryOfOrigin.id) {
                valid = false;
            } else {
                if (this.components.filter(c => !c.countryOfOrigin || !c.countryOfOrigin.id).length > 0) {
                    valid = false;
                }
            }
            this.$emit('validityChanged', valid);
        }
    },
    computed: {
        productName() {
            return this.product.names.length > 0 ? this.product.names[0].value : '';
        }
    },
    watch: {
        components() {
            this.emitValidity();
        }
    }
}
</script>
